import Vue from 'vue'
import router from '@/router'
import qs from 'querystring'
import { Request, bus } from '@/service'

export default class Authenticate {
  // 起動時の認証、自動ログイン
  static async doAuthorization () {
    let axios = Request.instance()
    // 通信は同期、結果をPromiseで返す
    return axios.get('/client/auth/verification')
    .then((res) => {
      // データを取得して、cookieへ設定する
      this.setUser(res.data)
      return true
    }).catch((error) => {
      console.log(error)
      return false
    })
  }

  static currentUser () {
    return JSON.parse(Vue.cookie.get('user'))
  }
  static setUser (user) {
    Vue.cookie.set('user', JSON.stringify(user))
    bus.$emit('update_user', user)
  }

  static doLogout () {
    Vue.cookie.delete('user')
    router.push({ path: '/auth/login' })
  }

  // AccessToken取得処理
  static async doSignin (groupId, mail, password) {
    let axios = Request.instance()
    return axios.post(
      '/client/auth/signin',
      qs.stringify({
        groupId: groupId,
        mail: mail,
        password: password
      })
    ).then((res) => {
      this.setUser(res.data)
      return true
    }).catch((error) => {
      console.log(error)
      return false
    })
  }
}



// WEBPACK FOOTER //
// ./src/service/Authenticate.js